import React from "react";
import { Container, Row, Col } from "reactstrap";

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer d-none d-md-flex align-items-md-center">
        <Container fluid={true}>
          <Row>
            <Col xl={5} lg={5} md={4} sm={6} xs={6}
              style={{ display: 'flex', alignItems: 'center' }}
            >
              {new Date().getFullYear()} © TheChart.AI
            </Col>
            <Col xl={4} lg={4} md={4} sm={6} xs={6}
              className="d-flex align-items-center justify-content-center"
            >
              <div className="text-sm-end">
                Contact us - Email: <a href="mailto:admin@thechart.ai">admin@thechart.ai</a>
              </div>
            </Col>
            <Col xl={3} lg={3} md={4} sm={12} xs={12}>
              <div className="text-sm-end d-none d-sm-block">
                Design & Develop by TheChartAI Team
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
